export default class User {
  userId: String;
  name: String;
}
